// Category keyword map for detectCat() — the name-based fallback used when a
// master product has no catalogTree. The only lookup the module still needs;
// all seed lists were removed with the mock-data machinery (PRD hygiene).
export const CAT_KW: Record<string, string[]> = {
  'Frozen Poultry': [
    'chicken',
    'poultry',
    'duck',
    'turkey',
    'quail',
    'broiler',
    'leg boneless',
    'chicken breast',
    'chicken wing',
    'drumstick',
    'whole chicken',
  ],
  'Fresh Poultry': ['fresh chicken', 'chilled chicken'],
  'Meat & Beef': ['beef', 'lamb', 'mutton', 'veal', 'steak', 'mince', 'burger', 'sausage', 'meat'],
  Seafood: ['fish', 'seafood', 'shrimp', 'prawn', 'salmon', 'tuna', 'crab', 'lobster', 'squid', 'hammour', 'tilapia'],
  'Fruits & Vegetables': [
    'tomato',
    'onion',
    'potato',
    'vegetable',
    'fruit',
    'pepper',
    'cucumber',
    'lettuce',
    'carrot',
    'broccoli',
    'garlic',
    'capsicum',
  ],
  'Rice & Grains': ['rice', 'basmati', 'jeera', 'grain', 'barley', 'wheat'],
  Oil: ['oil', 'sunflower', 'olive', 'canola'],
  Flour: ['flour', 'maida', 'atta', 'semolina'],
  Dairy: ['milk', 'cheese', 'butter', 'cream', 'yogurt', 'laban', 'ghee'],
  'Sauces & Condiments': ['sauce', 'ketchup', 'mayo', 'mustard', 'vinegar', 'chili', 'soy', 'spice'],
  'Dry Items': ['lentil', 'dal', 'chickpea', 'pulse', 'pasta', 'noodle', 'sugar', 'salt'],
  Packaging: ['box', 'container', 'bag', 'packaging', 'wrap', 'foil', 'cling'],
  'Pantry & Grocery': ['can', 'tin', 'canned', 'pickle', 'jam', 'honey'],
};
